// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys. :C

export const environment = {
    production: false,
    stage: 'prod',
    serverUrl: '/api',
    defaultLanguage: 'en-US',
    supportedLanguages: ['en-US', 'fr-FR'],
    apiUrl: 'https://nggax1u4c4.execute-api.us-east-1.amazonaws.com/prod/',
    api2Url: 'https://ivwl76jz71.execute-api.us-east-1.amazonaws.com/prod/',
    apiDashboards:
        'https://oeaw1fouik.execute-api.us-east-1.amazonaws.com/prod/',
    apiDashboards2:
        'https://9f5w6dxtb2.execute-api.us-east-1.amazonaws.com/dev/',
    apiDashboardPremiums:
        'https://ftbz398rp8.execute-api.us-east-1.amazonaws.com/prod/',
    apiDashboardsRfqPC:
        'https://pbyvgx6en3.execute-api.us-east-1.amazonaws.com/prod/',
    apiDashboardPremiumPC:
        'https://iyn719ea01.execute-api.us-east-1.amazonaws.com/dev/',
    apiClients: 'https://6p4vdpcqp4.execute-api.us-east-1.amazonaws.com/prod/',
    apiSeller: 'https://8gumvx7dfi.execute-api.us-east-1.amazonaws.com/prod/',
    apiAdminSeller:
        'https://gon4ve1goe.execute-api.us-east-1.amazonaws.com/prod/',
    apiSlsBfJiraSlack:
        'https://zvnlz5o7a9.execute-api.us-east-1.amazonaws.com/prod/',
    slsDbPreProcSubp:
        'https://7vv3shcj02.execute-api.us-east-1.amazonaws.com/prod/',
    apiProductClasification:
        'https://s1l99mpfm7.execute-api.us-east-1.amazonaws.com/prod/',
    apiSyncDashboards:
        'https://vpnza156cc.execute-api.us-east-1.amazonaws.com/prod/',
    apiProductsSales:
        'https://xrcgtw9l27.execute-api.us-east-1.amazonaws.com/prod/',
    apiProductsPremiumCharts:
        'https://pelo29yk0i.execute-api.us-east-1.amazonaws.com/prod/',
    apiProductsPremiumTables:
        'https://8q0e854zlj.execute-api.us-east-1.amazonaws.com/prod/',
    apiPremiumTables:
        'https://d0b0mr2axb.execute-api.us-east-1.amazonaws.com/prod/',
    apiAgents: 'https://u5uk10r6lf.execute-api.us-east-1.amazonaws.com/prod/',
    apiPremiumSquares:
        'https://0l3tdfhs31.execute-api.us-east-1.amazonaws.com/prod/',
    apiPremiumCharts:
        'https://2eu9px78fj.execute-api.us-east-1.amazonaws.com/prod/',
    apiNotifications:
        'https://wpjycwsfh5.execute-api.us-east-1.amazonaws.com/prod/',
    apiPopSquares:
        'https://ige3qzxlv9.execute-api.us-east-1.amazonaws.com/prod/',
    apiPopDashboards:
        'https://gj65jhdawh.execute-api.us-east-1.amazonaws.com/dev/',
    apiPopTables:
        'https://jg331l18u6.execute-api.us-east-1.amazonaws.com/prod/',
    apiPopProcessCompleted:
        'https://v6ov838gu9.execute-api.us-east-1.amazonaws.com/dev/',
    apiPopDashboadsRfqs:
        'https://p51vxequd7.execute-api.us-east-1.amazonaws.com/dev/',
    apiConekta: 'https://56labxl61l.execute-api.us-east-1.amazonaws.com/dev/',
    apiLogistic: 'https://x9sayrua5k.execute-api.us-east-1.amazonaws.com/prod/',
    apiAlendum: 'https://6kr6h8uy6i.execute-api.us-east-1.amazonaws.com/dev/',
    slsCrmJiraUrl:
        'https://clngz324p3.execute-api.us-east-1.amazonaws.com/prod/',
    apiClip: 'https://api-gw.payclip.com/checkout',
    apiPakMailUrl: 'https://500.api.pakmail.com.mx/api/v1/',
    apiPakMailKey: '95a64542cbc0093dda7a55b24f2c8a07',
    clipApiSecret: 'bc3aeffd-476b-48ce-9c88-85b0fd65a773',
    clipApiKey: '5ba14f0a-f469-4898-9d53-ba5c6b07914d',
    etPay: {
        merchantCode: 'mx_brand_factory',
        merchantApiToken:
            '3TzLw8Bo9s30jiu4QfP4dvddgUvG8F0OWzSes40ZYPR4YLdI0sGgGsZlwo9JU17o',
        apiUrl: 'https://mx-api.etpay.com',
        pmtUrl: 'https://qt.etpay.com',
        apiPlatformUrl: 'https://api-dashboard.etpay.com'
    },
    crmUrl: 'https://prod-pico.d14er4pbhay75s.amplifyapp.com/',
    warehouseUrl: 'https://develop.dewrlmr32ecqa.amplifyapp.com/',
    fmsUrl: 'https://develop.d3s2m6sdsjvjmf.amplifyapp.com/',
    slsFmsBackendUrl: 'https://xp2cbhbc0c.execute-api.us-east-1.amazonaws.com/',
    loggerSystemUrl: 'https://prod-pico.d26cm2z741jsxn.amplifyapp.com/',
    learningSystemUrl: 'https://develop.dzbd5rbcaldw3.amplifyapp.com/',
    atcSystemUrl: 'https://develop.d3s7zu0imwfoln.amplifyapp.com/',
    /** Base URL for SLS Logger API (no trailing slash). Used by SlsLoggerService. */
    slsLoggerBaseUrl:
        'https://b31c8m86uh.execute-api.us-east-1.amazonaws.com/prod/',
    /** API key for SLS Logger (list logs + create via ingest). */
    slsLoggerApiKey: 'plvhuq-onnPuk-altbqz',
    mailTo: 'notificationsdev@brandfactory.marketing',
    rfqMail: 'rfqdev@brandfactory.marketing',
    /** Credenciales S3: temporales del Identity Pool de Cognito (ver `amplifyS3Credentials`). */
    configS3: {
        region: 'us-east-1'
    },
    bucketImages: 'source-data-pico-imports-images-prod',
    bucketDocuments: 'source-data-docs-bf-picoprod',
    urlImages: 'https://source-data-pico-imports-images-prod.s3.amazonaws.com/',
    urlApp: 'https://prod-pico.d7awqdq07fcgo.amplifyapp.com',
    coupaClients: {
        procter: {
            id: '111111111111111111111111111111111111',
            url: 'https://pg-stage.coupahost.com/punchout/checkout?id=313',
            quality: 'Pablo Becerra'
        },
        herdez: {
            id: '3522201c-15d7-4493-bfb0-929d96dc32ed',
            url: 'https://grupoherdez-test.coupahost.com/punchout/checkout?id=6'
        },
        shell: {
            id: '9adcc607-bb45-4365-83b8-6ca855a9674e',
            url: 'https://dev.brandfacotry.marketing'
        },
        reckitt: {
            id: '313782e1-0543-474f-bf90-80353a16414b',
            url: 'https://dev.brandfacotry.marketing'
        },
        scotiabank: {
            id: '76d4069f-f5e3-4722-8d4f-7fc789f97315',
            url: 'scotiabanklifeshop.com'
        },
        danone: {
            id: 'baf8e795-51dd-4bef-a707-81012ca29a1e',
            url: 'https://danone-test.coupahost.com/punchout/checkout?id=127'
        },
        danone2: {
            id: 'baf8e795-51dd-4bef-a707-81012ca29a1e',
            url: 'https://danone-test.coupahost.com/punchout/checkout?id=127'
        },
        danone3: {
            id: 'baf8e795-51dd-4bef-a707-81012ca29a1e',
            url: 'https://danone-test.coupahost.com/punchout/checkout?id=127'
        },
        danone4: {
            id: 'baf8e795-51dd-4bef-a707-81012ca29a1e',
            url: 'https://danone-test.coupahost.com/punchout/checkout?id=127'
        },
        didi: {
            id: '21fca75c-88b3-4aff-843e-bb104ae3cced',
            url: 'scotiabanklifeshop.com'
        },
        sherwin: {
            id: '0d940b1e-3615-4449-84e5-89ded306db4f',
            url: 'https://sherwin-stage.coupahost.com/punchout/checkout?id=84'
        },
        pqp: {
            id: '0d940b1e-3615-4449-84e5-89ded306db4f',
            url: 'https://sherwin-stage.coupahost.com/punchout/checkout?id=87'
        },
        hogares: {
            id: '1ed7b37b-f8ac-42c5-b3e2-90818f184f3a',
            url: 'hogaresunion'
        },
        mattel: {
            id: 'dce01194-fbcf-4722-9588-9da9943beb18',
            url:
                'https://mattel-test.coupahost.com/punchout/checkout_test?id=34'
        },
        mattel2: {
            id: 'dce01194-fbcf-4722-9588-9da9943beb18',
            url: 'https://mattel-test.coupahost.com/punchout/checkout?id=34'
        },
        mattel3: {
            id: 'dce01194-fbcf-4722-9588-9da9943beb18',
            url: 'https://mattel-test.coupahost.com/punchout/checkout?id=34'
        },
        loreal: {
            id: 'e6134384-fc28-4115-8e0b-1c305e0eac00',
            url: 'https://mattel-test.coupahost.com/punchout/checkout?id=34'
        },
        mapfre: {
            id: '7144b6c4-0014-4bf3-af3e-1806487f063a',
            externalIds: ['629efa04-508d-49d9-9dfd-9a011990d4a8'],
            url: ''
        }
    },
    senderDomain: 'brandfactory.marketing',
    DUNS: 951566458,
    SharedSecret: '1kMpkwwd^KABGC3R69#t',
    subcategoryDiscountId: 'c20a3d67-8110-4bd8-b32a-6d9b73e82e94',
    BuyerCookie: '022fcf9200c90a4317c38663f97f6adb',
    Identity: 'sourcedata',
    enableOnlinePayments: false,
    showPublicPrices: false,
    notificationTypes: {
        EMAIL: 'Email',
        NGZORRO: 'Ng zorro',
        BROWSER: 'Browser'
    },
    categoriesMercadolibre: {
        categoryId: '81c46037-0e18-4f60-bde9-0be1c658cc37',
        categoryName: 'MERCADOLIBRE',
        subcategoryId: '74a1e69d-fc19-4d8b-942a-61bf0c3940a8',
        subcategoryName: 'MERCADOLIBRE',
        defaultProviderId: '884f8953-0629-4223-9609-5ddcde77b4b4'
    },
    bigSmartUrl: 'https://api.bigsmart.mx/',
    bigSmartToken:
        // tslint:disable-next-line: max-line-length
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiOTFlNTc2YWU5MzVmMzJlZjkzNjM0NWQyZWQxNTFkNDJiNTI4MTU3YzA1Y2EyMDJlNjE4NzQ4ODE3ZjdkNTEyOTk1ZGU4MDQxMDFmMTFmMjkiLCJpYXQiOjE2OTkzMTU2NjkuMzg2NDk4LCJuYmYiOjE2OTkzMTU2NjkuMzg2NSwiZXhwIjoxNzMwOTM4MDY5LjM3NTM0NCwic3ViIjoiODQ1MCIsInNjb3BlcyI6W119.srscIkEJjF8l4q9uIjhnaED-lIfRsZT_fSZ6arJbz338KZNyse41SjCrKDm0Xf5GqN0egUqxd8F-4UKibDQVcs1KS47wuJIwBlC2BB0LQrOe-d0Kw5CvXbK-2Xi9exykPC4tuN-h0IUqNQNRKCGFfaupUvvjZd3ke0w0H0FUDsGFmvQgB9nr9JSkE3K7uUg4f_BjJAODil0g9xSPnhdTI0nNPyO_d60c9BGLi9iHMjYvDf2MABV3NvdQvl9cnE_QJimSYf6NJ0SKha9eoMZ9dxClNJK5_ww9-bxeqrM_-q8lRfYC6YP8SG3rYOqPX9KyYq-oQNIQro1qU2iRXkz_1-tPKumYhukkT3pt4XzH9Li1r4XwQB7zKrjMU4gLoc1bNTabe-_RdQcwarFXZTL1xbsZOlneSAz7E6p0oHVbhM296TeaPBdvnRI3mouSzVAOJ1I1b7AorftwGavxEE-MasygGnyamSpDBUBoo_ElFzbq6Y31ngFLdTl7CX29ODhFH2MGVKfgeq1CVFeVmTmRvrKoJ_ire_pDOe7GMlR4KClgweTVbU90ATw0egVyIG4Idkp-mCUrMa8OtJ8cHYqxo1xiiRgIGBZpVx3mvJbmTjXchat-Ft1678MUJYlHyAqJDUmd-jmqn1_3b9QZQkbsXQGlqr_QAFYVYii7q2t1i18',
    urlDocusign: 'http://34.232.209.35',
    autosmails: ['omar@brandfactory.marketing'],
    shellAditionalApprovers: {
        'jessica.sotomayor@shell.com': [
            {
                name: 'Ximena Maeso',
                email: 'maria-ximena.maeso@shell.com',
                authorized: false
            },
            {
                name: 'Karla Lazcano',
                email: 'karla.lazcano@shell.com',
                authorized: false
            }
        ],
        'karla.lazcano@shell.com': [
            {
                name: 'Ximena Maeso',
                email: 'maria-ximena.maeso@shell.com',
                authorized: false
            }
        ]
    },
    pingId: {
        verifyDomain: 'procter',
        cognitoHostedUi:
            'https://auth0brand.auth.us-east-1.amazoncognito.com/login?client_id=5tupchdjerf2k9e3ib55cup1e0&response_type=token&scope=email+openid+profile&redirect_uri=https%3A%2F%2Fdevelop.d2ot0ibkt8plur.amplifyapp.com'
    },
    coupaSub: '5123ba7f-c481-40c2-b8c2-a199d5cfc941',
    sourceDataProviderId: 'dc0060cd-99b5-4c31-867b-6ff8f8aa8f6d',
    sourceDataClientId: 'a3f0dd51-5230-4b01-a084-d8b00393a740',
    blackList: ['omar1@brandfactory.marketing'],
    automobilesLimitDate: 20,
    jira: {
        assignee_id: '712020:f9720750-cce9-48ee-af7c-335fbc3d1433',
        projectKeys: {
            op: 'OPPDEV',
            ot: 'OTPDEV',
            oc: 'OCPDEV',
            of: 'OFPDEV'
        },
        userGroups: {
            operations: 'OPERACIONES_DEV',
            admonFinance: 'ADMINISTRACION_Y_FINANZAS_DEV'
        }
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
